module.exports = __webpack_public_path__ + "fonts/fa-regular-400.52d4b33.woff";